import { USER_ROLES } from '../../../utils/constants';
import { TimelineParty } from '../../../slices/marketplace/timeline/models/enums/timeline-party.enum';
import { isCharityAffiliatedMember } from '../../../utils/memberRoles';

export { isCharityAffiliatedMember };

const hasEngagementParty = (summary: any, party: TimelineParty): boolean =>
    (summary?.engagements ?? []).some((e: any) => e.party === party);

export const canAccessAnnouncements = (summary: any): boolean => {
    if (!summary) return false;

    if (summary.roleId === USER_ROLES.ADMIN) return false;
    if (summary.roleId === USER_ROLES.CHARITY_ADMIN) return false;
    if (summary.isMarketplaceBuyer) return false;
    if (summary.isMarketplaceBroker) return false;
    if (hasEngagementParty(summary, TimelineParty.Observer)) return false;
    if (isCharityAffiliatedMember(summary)) return false;

    if (summary.roleId === USER_ROLES.PRACTICE_SECONDARY_USER) return false;

    return true;
};
